import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Breadcrumbs,
  Grid,
  Card,
  CardContent,
  Chip,
  Button,
  List,
  ListItem,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableBody,
  Divider,
  useTheme,
} from "@mui/material";
import {
  MenuBook,
  Science,
  Language,
  Psychology,
  SportsHandball,
  Calculate,
  History,
  Architecture,
  Church,
  Translate,
  Public,
  MusicNote,
  BiotechOutlined,
  Science as Chemistry,
  Brush,
  EmojiObjects,
  School,
} from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import HandymanIcon from "@mui/icons-material/Handyman";
import ShortcutBox from "./ShortcutBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InfoBox from "./InfoBox";
import GenerateIcon from "@mui/icons-material/AutoAwesome";
import { Palette as PaletteIcon } from "@mui/icons-material";
import LessonBankDialog from "./LessonBankDialog";
import { Abc as AbcIcon } from "@mui/icons-material";

import { subjects } from "./ThemeSelector";

import ThemeFlowBox from "./ThemeFlowBox";
import { getStyles } from "../index";
import { shortcuts } from "./DashboardToolsShortcuts";
import {
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  getDoc,
  onSnapshot,
} from "firebase/firestore";

import { db } from "./firebase";
const TeacherShortcuts = ({ user }) => {
  const [selectedCategory, setSelectedCategory] = useState("Svenska");
  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();
  const [isShimmering, setIsShimmering] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [lessonType, setLessonType] = useState(null);

  const [favoriteShortcuts, setFavoriteShortcuts] = useState([]);
  const [openLessonBank, setOpenLessonBank] = useState(false);

  const filterItemsBySearch = (items) => {
    if (!searchQuery.trim()) return items;
    return items.filter((item) =>
      item.title.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  };

  useEffect(() => {
    if (!user?.uid) return;

    const userRef = doc(db, "users", user.uid);

    const unsubscribe = onSnapshot(
      userRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          // favoriteShortcuts is now an array of objects: [{id: string, subject: string}]
          setFavoriteShortcuts(data.favoriteShortcuts || []);
        }
      },
      (error) => {
        console.error("Error listening to favorites:", error);
      },
    );

    return () => unsubscribe();
  }, [user]);

  const getShortcutsBySubject = (subject) => {
    return shortcuts
      .filter(
        (shortcut) =>
          shortcut.belongsTo &&
          shortcut.belongsTo
            .split(",")
            .map((s) => s.trim())
            .includes(subject),
      )
      .map((shortcut) => ({
        ...shortcut,
        //path: `${shortcut.path}${shortcut.path.includes("?") ? "&" : "?"}subject=${encodeURIComponent(subject.toLowerCase())}`,
        //path: `${shortcut.path}`,
      }));
  };

  const shortcuts2 = {
    Svenska: {
      clickable: true,
      icon: MenuBook,
      content: {
        Svenska: [...getShortcutsBySubject("Svenska")],
      },
    },
    Biologi: {
      clickable: true,
      icon: BiotechOutlined,
      content: {
        Biologi: [...getShortcutsBySubject("Biologi")],
      },
    },

    Matematik: {
      clickable: true,
      icon: Calculate,
      content: {
        Matematik: [...getShortcutsBySubject("Matematik")],
      },
    },
    NO: {
      clickable: true,
      icon: Science,
      content: {
        NO: [...getShortcutsBySubject("NO")],
      },
    },
    SO: {
      clickable: true,
      icon: Public,
      content: {
        SO: [...getShortcutsBySubject("SO")],
      },
    },
    Historia: {
      clickable: true,
      icon: History,
      content: {
        Historia: [...getShortcutsBySubject("Historia")],
      },
    },
    Kemi: {
      clickable: true,
      icon: Chemistry,
      content: {
        Kemi: [...getShortcutsBySubject("Kemi")],
      },
    },
    Engelska: {
      clickable: true,
      icon: Language,
      content: {
        Engelska: [...getShortcutsBySubject("Engelska")],
      },
    },
    Geografi: {
      clickable: true,
      icon: Public,
      content: {
        Geografi: [...getShortcutsBySubject("Geografi")],
      },
    },
    Teknik: {
      clickable: true,
      icon: Architecture,
      content: {
        Teknik: [...getShortcutsBySubject("Teknik")],
      },
    },
    Religion: {
      clickable: true,
      icon: Church,
      content: {
        Religion: [...getShortcutsBySubject("Religion")],
      },
    },
    Modersmål: {
      clickable: true,
      icon: School,
      content: {
        Modersmål: [...getShortcutsBySubject("Modersmål")],
      },
    },
    "Moderna språk": {
      clickable: true,
      icon: Translate,
      content: {
        "Moderna språk": [...getShortcutsBySubject("Moderna språk")],
      },
    },
    Samhällskunskap: {
      clickable: true,
      icon: Psychology,
      content: {
        Samhällskunskap: [...getShortcutsBySubject("Samhällskunskap")],
      },
    },
    Spanska: {
      clickable: true,
      icon: Language,
      content: {
        Spanska: [...getShortcutsBySubject("Spanska")],
      },
    },
    Franska: {
      clickable: true,
      icon: Language,
      content: {
        Franska: [...getShortcutsBySubject("Franska")],
      },
    },
    Tyska: {
      clickable: true,
      icon: Language,
      content: {
        Tyska: [...getShortcutsBySubject("Tyska")],
      },
    },
    Musik: {
      clickable: true,
      icon: MusicNote,
      content: {
        Musik: [...getShortcutsBySubject("Musik")],
      },
    },
    "Idrott och hälsa": {
      clickable: true,
      icon: SportsHandball,
      content: {
        "Idrott och hälsa": [...getShortcutsBySubject("Idrott och hälsa")],
      },
    },
    "Trä och metallslöjd": {
      clickable: true,
      icon: HandymanIcon,
      content: {
        "Trä och metallslöjd": [
          ...getShortcutsBySubject("Trä och metallslöjd"),
        ],
      },
    },

    Hemkunskap: {
      clickable: true,
      icon: HandymanIcon,
      content: {
        hemkunskap: [...getShortcutsBySubject("Hemkunskap")],
      },
    },

    Fysik: {
      clickable: true,
      icon: Calculate,
      content: {
        Fysik: [...getShortcutsBySubject("Fysik")],
      },
    },
  };

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          ...styles.innerContainer,
          width: { xs: "100%", md: "100%" },
          margin: "0 auto",
          paddingRight: "0px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 20,
            width: 250,
            zIndex: 5,
          }}
        >
          <TextField
            size="small"
            placeholder="Sök lektioner..."
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: "50px",

              "& .MuiInputBase-root": {
                backgroundColor:
                  theme.palette.mode === "dark" ? "#15202b" : "#ececec",
                borderRadius: "50px",
                height: "43px",
              },

              "& .MuiOutlinedInput-notchedOutline": {
                border: "0 !important",
                outline: "none !important",
                boxShadow: "none !important",
                borderRadius: "50px",
              },
              "& .MuiOutlinedInput-root": {
                border: "0 !important",
                outline: "none !important",
                borderRadius: "50px",
                boxShadow: "none !important",
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "0 !important",
                  outline: "none !important",
                  boxShadow: "none !important",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "0 !important",
                  outline: "none !important",
                  boxShadow: "none !important",
                },
              },
            }}
          />
        </Box>

        <Box sx={{ display: "none" }}>
          <Box sx={styles.headlineLessonBox}>
            <Typography variant="h6" sx={styles.headlineLessonBoxTitle}>
              <span>1</span> Välj ämne
            </Typography>
          </Box>
          <Box sx={{ ...styles.newBox, padding: "20px", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              {Object.entries(shortcuts2).map(([category, categoryData]) => (
                <Chip
                  key={category}
                  icon={<categoryData.icon sx={{ fontSize: "22px" }} />}
                  label={category}
                  sx={{
                    fontWeight: "500",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    fontSize: "0.92rem",
                    borderRadius: 2,
                  }}
                  onClick={() => {
                    if (
                      categoryData.clickable &&
                      category !== selectedCategory
                    ) {
                      setIsShimmering(true);
                      setSelectedCategory(category);
                      setTimeout(() => setIsShimmering(false), 1000);
                    }
                  }}
                  color={selectedCategory === category ? "primary" : "default"}
                />
              ))}
            </Box>
          </Box>

          <Box sx={{ ...styles.headlineLessonBox, mt: 7 }}>
            <Typography variant="h6" sx={styles.headlineLessonBoxTitle}>
              <span>2</span> Välj typ av lektion
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "none" }}>
          <Typography
            variant="h1"
            gutterBottom
            sx={{
              ...styles.newH1,
            }}
          >
            Generera lektioner
          </Typography>
          <InfoBox
            title="Fiktiva dagböcker"
            instructions={[
              "Generera fiktiva dagboksinlägg från t.ex. en historisk händelse eller historisk person",
              "Redigera, generera bilder, lägg till övningar efter eget behov",
              "Dela med elever, spara eller skriv ut",
            ]}
            theme={theme}
            styles={styles}
            user={user}
          />
        </Box>
        <Box sx={{ mt: 0 }}>
          {/* Subject Selection Row */}
          <Typography
            variant="h1"
            sx={{
              ...styles.newH1,
              mt: 0,
              pt: 0,
              pl: 0,
              pb: 5,
              width: "100%",
              textAlign: "left",
              //display: "none",
            }}
          >
            Välj typ av lektion
          </Typography>
          {/* Shortcuts Display */}
          {selectedCategory && (
            <Box
              sx={{
                position: "relative",
              }}
            >
              {Object.entries(shortcuts2[selectedCategory].content).map(
                ([subcategory, items]) => {
                  return (
                    <Box key={subcategory}>
                      <Grid container spacing={3}>
                        {items.length > 0 ? (
                          [...filterItemsBySearch(items)]
                            .sort((a, b) => {
                              const priority = {
                                Läsförståelse: 2,

                                Tidslinjer: 4,
                                Tankekartor: 5,
                                "Grej of the day": 6,
                                "Historisk person": 7,
                                "Hitta orden": 8,
                                "Glosor i lådor": 9,

                                Rollkort: 9,
                                "Debatt & Argument": 10,
                                Målarbilder: 10,

                                Nyhetsredaktionen: 10,
                                Recension: 10,
                                Jeopardy: 11,

                                "Escape Room": 12,
                                "På spåret": 13,
                                "Bygg tidslinjer": 14,
                              };

                              const aValue = priority[a.title] || 999;
                              const bValue = priority[b.title] || 999;
                              return aValue - bValue;
                            })
                            .map((item, index) => {
                              return (
                                <Grid item xs={12} md={4} key={index}>
                                  <Link
                                    to={item.path}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <Paper
                                      elevation={2}
                                      sx={{
                                        ...styles.freshBox,
                                        transition: "all 0.3s ease",
                                        cursor: "pointer",
                                        "&:hover": {
                                          transform: "translateY(-4px)",
                                          "& .buttons": {
                                            opacity: 1,
                                            transform: "translateY(0)",
                                          },
                                          "& .title-text": {
                                            mt: 2, // Change to desired margin-top on hover
                                          },
                                        },
                                        height: "300px",
                                        backgroundColor: (theme) =>
                                          theme.palette.background.paper,
                                        borderRadius: 4,
                                        //boxShadow: "none",
                                        backgroundImage: "none",
                                        ...styles.softBoxShadow,
                                        p: 4,
                                        overflow: "hidden",
                                        mb: 2,
                                        textAlign: "center",
                                        position: "relative", // Added for ribbon positioning
                                      }}
                                    >
                                      {(item.title === "Tungvrickare" ||
                                        item.title === "Idiomatiska uttryck" ||
                                        item.title === "Skriv fint" ||
                                        item.title === "Mystiska bilden") && (
                                        <>
                                          {/* Stop propagation to prevent link navigation */}
                                          <Box
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                            }}
                                            sx={{
                                              position: "absolute",
                                              top: 0,
                                              left: 0,
                                              width: "100%",
                                              height: "100%",
                                              backgroundColor: (theme) =>
                                                theme.palette.mode === "dark"
                                                  ? "rgba(30, 30, 30, 0.85)"
                                                  : "rgba(255, 255, 255, 0.85)",
                                              backdropFilter: "blur(30px)",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              zIndex: 2,
                                              borderRadius: 4,
                                              cursor: "default",
                                            }}
                                          >
                                            <Typography
                                              variant="h6"
                                              sx={{
                                                color: "text.secondary",
                                                fontWeight: 600,
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px",
                                              }}
                                            >
                                              Kommer snart...
                                            </Typography>
                                          </Box>
                                        </>
                                      )}
                                      {/* Diagonal Ribbon */}
                                      {item.label && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            top: 20,
                                            left: -35,
                                            width: 150,
                                            transform: "rotate(-45deg)",
                                            backgroundColor: (theme) =>
                                              theme.palette.primary.main,
                                            color: "#fff",
                                            padding: "8px 0",
                                            textAlign: "center",
                                            fontWeight: 600,
                                            textTransform: "uppercase",
                                            fontSize: "0.75rem",
                                            boxShadow:
                                              "0 2px 5px rgba(0,0,0,0.1)",
                                            zIndex: 1,
                                            overflow: "hidden",
                                          }}
                                        >
                                          {item.label}
                                        </Box>
                                      )}

                                      <Typography
                                        variant="h5"
                                        className="title-text"
                                        sx={{
                                          fontWeight: 600,
                                          mb: 2,
                                          fontSize: "1.8rem",
                                          mt: 6, // Added margin top to account for ribbon
                                          transition: "margin-top 0.3s ease",
                                        }}
                                      >
                                        {item.title}
                                      </Typography>

                                      <Box
                                        sx={{
                                          display: "flex",

                                          justifyContent: "center",
                                          width: "100%",
                                          my: 4,
                                        }}
                                      >
                                        <img
                                          src={item.welcomeDialogImg}
                                          alt={item.title}
                                          style={{
                                            width: "60px", // Sets specific width (optional)
                                          }}
                                        />
                                      </Box>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          color: "text.secondary",
                                          fontSize: "0.95rem",

                                          lineHeight: 1.6,
                                          display: "none",
                                        }}
                                      >
                                        {item.subtitle}
                                      </Typography>

                                      {/* Button positioned at bottom center */}
                                      <Box
                                        className="buttons"
                                        sx={{
                                          position: "absolute",
                                          bottom: 30,
                                          left: 0,
                                          right: 0,
                                          display: "flex",
                                          justifyContent: "center",
                                          opacity: 0,
                                          transform: "translateY(10px)",
                                          transition: "all 0.3s ease",
                                        }}
                                      >
                                        <Button
                                          variant="purp"
                                          sx={{
                                            borderBottom: 0,
                                          }}
                                        >
                                          Generera
                                        </Button>

                                        <Button
                                          variant="print"
                                          sx={{ ml: 3, borderBottom: 0 }}
                                          onClick={(e) => {
                                            e.preventDefault(); // Prevent navigation from Link component
                                            e.stopPropagation();
                                            let lessonType = item.lessonType;
                                            let targetUrl = "";
                                            console.log(
                                              "lessonType TeacherShortcuts: ",
                                              lessonType,
                                            );
                                            if (
                                              lessonType ===
                                              "LessonPlanRevamp.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lektionsplan/9sNMqcKh0S";
                                            } else if (
                                              lessonType === "JeopardyLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/jeopardy/Wjf2cWXQir";
                                            } else if (
                                              lessonType === "TimelineLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/tidslinjer/1WsWSwO1CZ";
                                            } else if (
                                              lessonType ===
                                              "BasicReadingCompLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lasforstaelse/N46W8qE4wP";
                                            } else if (
                                              lessonType ===
                                              "BasicReadingCompLessonVariantFactText.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lasforstaelse/sfzkAeuJ22?type=factText";
                                            } else if (
                                              lessonType ===
                                              "BasicReadingCompLessonVariantInstructingText.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lasforstaelse/A6TAZCV7fU?type=instructingText";
                                            } else if (
                                              lessonType ===
                                              "BasicReadingCompLessonVariantExplainingText.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lasforstaelse/7XOuiEc3kD?type=explainingText";
                                            } else if (
                                              lessonType ===
                                              "BasicReadingCompLessonVariantArgumentativeText.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lasforstaelse/ug3txMBUZY?type=argumentativeText";
                                            } else if (
                                              lessonType ===
                                              "BasicReadingCompLessonVariantDescriptiveText.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/lasforstaelse/8RrTHhJz1E?type=descriptiveText";
                                            } else if (
                                              lessonType === "MindMapLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/tankekartor/I7qKiME1td";
                                            } else if (
                                              lessonType === "RolePlayLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/rollkort/29hmsRNaZ6";
                                            } else if (
                                              lessonType ===
                                              "EscapeRoomLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/escape-room/94u26m0hqB";
                                            } else if (
                                              lessonType === "DiaryLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/fiktiva-dagbocker/jyUXRz9SHp";
                                            } else if (
                                              lessonType ===
                                              "HistoricPersonLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/historisk-person/rDSrOCAa9p";
                                            } else if (
                                              lessonType === "LettersLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/fiktiva-brev/1ec35VP3ju";
                                            } else if (
                                              lessonType ===
                                              "LiteratureSchool.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/litteraturskolan/9J4GY1ElLo";
                                            } else if (
                                              lessonType ===
                                              "TimelineBuilderLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/bygg-tidslinjer/79n31gpSHk";
                                            } else if (
                                              lessonType === "NewsLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/fiktiva-nyhetsredaktionen/2GKNnMWwW0";
                                            } else if (
                                              lessonType === "GrejOfTheDay.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/grej-of-the-day/y6zglZOLT1";
                                            } else if (
                                              lessonType ===
                                              "ConversationLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/konversation/8PEm3ZbYmW";
                                            } else if (
                                              lessonType ===
                                              "ConversationLessonVariantInterview.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/konversation/byxjKAln0Q?type=interview";
                                            } else if (
                                              lessonType === "ClueGenerator.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/pa-sparet/AVGAYBUbn1";
                                            } else if (
                                              lessonType ===
                                              "SentenceFinisherLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/fortsatt-berattelsen/rc8jQ0hkSX";
                                            } else if (
                                              lessonType ===
                                              "NarrativeLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/berattande-text/zU5Vbfitpa";
                                            } else if (
                                              lessonType ===
                                              "TermsGridLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/glosor-i-lador/1mRLhokexN";
                                            } else if (
                                              lessonType ===
                                              "LetterBoxLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/bokstaver/GTwb6hw4is";
                                            } else if (
                                              lessonType ===
                                              "FindWordsLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/hitta-orden/n1p0y8r2ge";
                                            } else if (
                                              lessonType ===
                                              "ArgumentationLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/argumentera/vTG2ix77SV";
                                            } else if (
                                              lessonType ===
                                              "PowerPointGenerator.js"
                                            ) {
                                              targetUrl =
                                                "/app/generera-powerpoint/4zDhrMTxcM";
                                            } else if (
                                              lessonType === "GrammarLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/grammatik/PheP22vOZN";
                                            } else if (
                                              lessonType === "ColoringLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/malarbilder/oU7o7CQBnC";
                                            } else if (
                                              lessonType ===
                                              "WeeklyWordsLesson.js"
                                            ) {
                                              targetUrl =
                                                "/app/lektioner/veckans-ord/YeSn4Pc1yp";
                                            }

                                            navigate(targetUrl);
                                          }}
                                        >
                                          Exempel
                                        </Button>
                                      </Box>
                                    </Paper>
                                  </Link>
                                </Grid>
                              );
                            })
                        ) : (
                          <Grid item xs={12}>
                            <Paper sx={{ p: 4, textAlign: "center" }}>
                              <Typography
                                variant="h6"
                                sx={{ color: "text.secondary" }}
                              >
                                Snart kommer det lektioner för {subcategory} här
                                :)
                              </Typography>
                            </Paper>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  );
                },
              )}

              {Object.entries(shortcuts2[selectedCategory].content).map(
                ([subcategory, items]) => {
                  // Log the subcategory and its items
                  console.log("Subcategory:", subcategory);
                  console.log("Items:", items);

                  return (
                    <Box key={subcategory}>
                      <Typography
                        variant="h6"
                        sx={{
                          mb: 2,
                          mt: 6,
                          fontWeight: "600",
                          fontSize: "23px",
                          textAlign: "center",
                          display: "none",
                        }}
                      >
                        {subcategory}
                      </Typography>
                      <Grid container spacing={2} sx={{ display: "none" }}>
                        {items.length > 0 ? (
                          items.map((item, index) => {
                            // Log each individual item
                            console.log(`Item ${index}:`, item);

                            return (
                              <Grid item xs={12} sm={6} md={4} key={index}>
                                <ShortcutBox
                                  user={user}
                                  {...item}
                                  diffView={false}
                                  currentSubject={selectedCategory}
                                  isFavorite={favoriteShortcuts.some(
                                    (fav) =>
                                      fav.id === item.id &&
                                      fav.subject === selectedCategory,
                                  )}
                                  onFavoriteChange={(id, newIsFavorite) => {
                                    // The state will be automatically updated by the onSnapshot listener
                                  }}
                                />
                              </Grid>
                            );
                          })
                        ) : (
                          <Grid item xs={12}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                py: 2,
                                width: "100%",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{ color: "text.secondary" }}
                              >
                                Snart kommer det lektioner för {subcategory} här
                                :)
                              </Typography>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  );
                },
              )}
            </Box>
          )}
        </Box>
      </Box>
      <LessonBankDialog
        open={openLessonBank}
        onClose={() => setOpenLessonBank(false)}
        user={user}
        styles={styles}
        theme={theme}
        lessonType={lessonType}
      />
    </Box>
  );
};
export default TeacherShortcuts;
